/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const d={Left:0,Middle:1,Right:2,Back:3,Forward:4,Undefined:-1};export{d as mouseButtons};
